import { ProviderImageSvg } from '@/components/svgs/provider-image';
import { useTranslation } from '@/contexts/i18n-context';
import { useState } from 'react';
import styles from './provider-image.module.css';
import clsx from 'clsx';

interface ProviderImageProps {
  url: string | null;
  className?: string;
}

export function ProviderImage({ url, className }: ProviderImageProps) {
  const { t } = useTranslation();
  const [showFallback, setShowFallback] = useState(false);

  const imageClassName = clsx(styles.providerImg, className);

  if (showFallback || !url) {
    return <ProviderImageSvg className={imageClassName} />;
  }

  return (
    <img
      src={url}
      alt={t('visit.providerSelection.providerAlt')}
      onError={() => setShowFallback(true)}
      className={imageClassName}
    />
  );
}
